import { LitElement, html } from 'lit-element';


export const renderMenu = (data, elems) => data ?
html`
<nav class="${data.styles||''}" id="${data.id||''}">
${elems}
</nav>
`
: null
